import { useRouter } from "next/router";
import { useEffect } from "react";

function FlixMedia({ product }) {
  const sku = Array.isArray(product?.sku) ? product?.sku?.at(0) : product?.sku;
  const product_ean = Array.isArray(product?.ean)
    ? product?.ean?.at(0)
    : product?.ean;
  const product_brand = Array.isArray(product?.option_text_brand)
    ? product?.option_text_brand?.at(0)
    : product?.option_text_brand;
  console.log("flixmedia", { sku, product_brand, product_ean });
  const { locale } = useRouter();
  useEffect(() => {
    const distributor = "14091";
    const language = (locale === "ar" ? "ar" : "en") || "d2";
    const headID = document.getElementsByTagName("head")[0];
    const flixScript = document.createElement("script");
    flixScript.type = "text/javascript";
    flixScript.async = true;
    flixScript.id = "1452";
    flixScript.setAttribute("data-flix-distributor", distributor);
    flixScript.setAttribute("data-flix-language", language);
    flixScript.setAttribute("data-flix-fallback-language", "en");
    flixScript.setAttribute("data-flix-brand", product_brand);
    flixScript.setAttribute("data-flix-ean", product_ean);
    flixScript.setAttribute("data-flix-mpn", "");
    flixScript.setAttribute("data-flix-sku", sku);
    flixScript.setAttribute("data-flix-inpage", "flix-inpage");
    flixScript.setAttribute("data-flix-button-image", "");
    flixScript.setAttribute("data-flix-button", "flix-minisites");
    flixScript.setAttribute("data-flix-price", "");
    flixScript.src = "//media.flixfacts.com/js/loader.js";
    headID.appendChild(flixScript);

    return () => {
      const ele = document.getElementById("1452");
      console.log("ele", ele);
      ele ? ele?.remove() : null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);

  return <></>;
}

export default FlixMedia;
